import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MedChronEvent } from './schemas'

export type MedChronEventsState = {
  events: { [job_id: string]: MedChronEvent[] }
}

const initialState: MedChronEventsState = {
  events: {},
}

export const medChronEventsSlice = createSlice({
  name: 'medChronEventsState',
  initialState,
  reducers: {
    nullifyData: () => initialState,

    setJobEventsList: (state, action: PayloadAction<{ medChronJobId: string; events: MedChronEvent[] }>) => {
      state.events[action.payload.medChronJobId] = action.payload.events
    },
  },
})

// Actions
export const MedChronEventsActions = medChronEventsSlice.actions

export default medChronEventsSlice.reducer
